import Permittee from "~/models/permittee";
import Dashboard from "~/models/dashboards/dashboard";

export default class DashboardAssignment extends Permittee<Dashboard> {
  reference_helpers: {name: string, first_name: string, last_name: string, email: string, activation_status: number, group_type: number}
  organization_id_where_assigned: string;
}